import React from 'react'

const Carddetailbranch = ({ list, handleonClick,
  className = "ms-3 mt-1 shadow mx-3" }) => {

  return (
    <>

      { <div
        style={{ width: 70, maxHeight: 30, fontSize: "12px" }}
        className={className}
      >
        {list && list.statusid == 1 ? (
          <div className=" d-flex justify-content-center  
          ">
            <span
              className="badge bg-success "
              style={{ fontSize: "12px", cursor: 'pointer',alignItems: 'center' }}
              onClick={() =>
                handleonClick(list.id)
              }
            >
              {" "}
              {list.drivenno} {list.drivenprov}{" "}
            </span>
          </div>
        ) : list && list.statusid == 2 ? (
          <div className="d-flex justify-content-center
          ">
            <span
              className="badge bg-info text-dark"
              style={{ fontSize: "12px", cursor: 'pointer',alignItems: 'center' }}
              onClick={() =>
                handleonClick(list.id)
              }
            >
              {" "}
              {list.drivenno} {list.drivenprov}{" "}
            </span>
          </div>
        ) : list && list.statusid == 4 ? (
          <div className="d-flex justify-content-center
          ">
            <span
              className="badge bg-danger"
              style={{ fontSize: "12px", cursor: 'pointer',alignItems: 'center' }}
              onClick={() =>
                handleonClick(list.id)
              }
            >
              {" "}
              {list.drivenno} {list.drivenprov}{" "}
            </span>
          </div>
        ) : list && list.statusid == 0 ? (
          <div className="d-flex justify-content-center
          ">
            <span
              className="badge  bg-warning text-dark"
              style={{ fontSize: "12px", cursor: 'pointer',alignItems: 'center' }}
              onClick={() =>
                handleonClick(list.id)
              }
            >
              {" "}
              {list.drivenno} {list.drivenprov}{" "}
            </span>
          </div>
        ) : null}


      </div>}

    </>
  );
}

export default Carddetailbranch;